/**
 * @changelog
 *
 * 2026-10-15 (0.1.0) (jhoward)
 *   - Add safeRedirectPath(), which accepts a ?redirect= value only when it is a path on this site.
 */

/**
 * The value as a path on this site, or null. A single leading slash only: '//host' and '/\host' are read by browsers
 * as another site, and anything with a scheme is one.
 */
export default function safeRedirectPath(value: unknown): string | null {
  if (typeof value !== 'string' || !/^\/(?![/\\])/.test(value)) {
    return null;
  }

  return value;
}
